export default __webpack_public_path__ + "img/5e44af48e8129c92dc5847b060fb184d.png";